import logo from './logo.svg';
import './App.css';
import LandingBMNEPSI from './Landing';

function App() {
  return (
    <div className="App">
      <LandingBMNEPSI />
    </div>
  );
}

export default App;
